<template>
  <div>
    <v-idle @idle="onidle" :duration="1800"/>
    <ChatWidget v-if="$store.getters.Paket==1"></ChatWidget>
    <KisaYol></KisaYol>
  </div>
</template>

<script>

import ChatWidget from "../Pack/Chat/ChatWidget";
import KisaYol from "../Pack/Spesiyal/KisaYol";


export default {
  components: {KisaYol, ChatWidget},
  data() {
    return {
      Kilitli: JSON.parse(localStorage.getItem("_aiLock")),
      Bosta: false
    }
  },
  methods: {
    onidle() {
      if (!this.Kilitli) this.open()
    },
    Kilitle() {
      localStorage.setItem("_aiLock", true);
      this.Kilitli = true
      this.KilitEkran()
    },
    KilitEkran() {
      this.$prompt('Lütfen parolanızı giriniz', 'Ekran Kilitli', {
        confirmButtonText: 'Kilit Aç',
        cancelButtonText: 'Çıkış Yap',
        cancelButtonClass: 'el-button--danger',
        closeOnPressEscape: false,
        closeOnClickModal: false,
        type: 'warning',
        center: true
      }).then(({value}) => {
        this.ParolaDogrula(value);
      }).catch(() => {
        this.Cikis()
      });
      $(".el-message-box__close.el-icon-close").remove();
    },
    ParolaDogrula(parola) {
      if (parola) {
        this.$store.dispatch("Get", {path: 'spesiyal/parola/' + parola})
          .then(response => {
            if (response.Durum === 'OK') {
              this.$message.info(response.Mesaj);
              localStorage.setItem("_aiLock", false);
              this.Kilitli = false
            } else {
              this.$message.error(response.Mesaj);
              this.KilitEkran()
            }
          });
      } else {
        this.$message.error("Parola Giriniz");
        this.KilitEkran()
      }
    },
    Cikis() {
      this.$store.dispatch("Get", {path: 'spesiyal/cikis', loading: false})
        .then(response => {
          if (response.Durum === 'OK') {
            this.$store.dispatch("logout");
          }
        });
    },
    open() {
      this.Bosta = true
      this.$confirm('5dk boyunca işlem yapmadınız. Ekran 10sn içinde kilitlenecektir.', 'Zaman Aşımı', {
        confirmButtonText: 'Hemen Kilitle',
        cancelButtonText: 'Buradayım',
        type: 'info',
        center: true
      })
        .then(() => {
          this.Kilitle()
        })
        .catch(() => {
          this.Bosta = false
          this.$message({
            type: 'info',
            message: 'Kolay gelsin...',
            showClose: false
          });
        });
      if (this.Bosta) {
        setTimeout(() => {
          this.Kilitle()
          location.href = "/panel"
        }, 10000);
      }
    }

  },
  created() {
    if (this.Kilitli) this.KilitEkran()
  },


}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Doc/Footer.vue